export const designContentSelector = state => state.designContent;
export const designSelector = state => state.designContent.design;
